import { useEffect, useState } from "react"
import Form from 'react-bootstrap/Form'

import { Control, SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"

import * as Basic from "../../../Modules/BasicFields"

const twitchAudiencePickerVariables = [
    {name:'Output', key:'output', type:'W'},
]

export default function RngKing( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const selected = props.selected
    const reset = props.reset

    const [ hashtag, setHashtag ] = useState(null)

    const [ startHashtag, setStartHashtag ] = useState(null)
    const [ minHashtags, setMinHashtags ] = useState(null)
    const [ hashtagRate, setHashtagRate ] = useState(null)

    const [ stopAfter, setStopAfter ] = useState(null)
    const [ cooldown, setCooldown ] = useState(null)
    const [ preselection, setPreselection ] = useState(null)

    const [ font, setFont ] = useState(null)
    const [ variables, setVariables ] = useState(null)

    const requiredData = [
        hashtag,
        startHashtag,
        minHashtags,
        hashtagRate,
        stopAfter,
        cooldown,
        preselection,
        font,
        variables
    ]

    const cfgName = "kingmaker_rng_king_cfg"

    const reload = () => {
        let properties = dynoCfg.properties

        let cfg = properties[cfgName] || {}

        setHashtag( cfg.hashtag || "" )  
        setStartHashtag( cfg.start_hashtag || ""  )
        //setStopHashtag( (cfg.stop_hashtag) ? cfg.stop_hashtag : "" )
        setMinHashtags( ( cfg.min_hashtags != null ) ? cfg.min_hashtags : 1 )
        setHashtagRate( cfg.hashtag_rate || "one_per_user" )
        setStopAfter( cfg.stop_after || 0 )
        setCooldown( cfg.cooldown || 0 )
        setPreselection( cfg.preselection || "all" )
        setFont( cfg.font || {} )
        setVariables( cfg.variables || {} )
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {
        if( requiredData.includes(null) )
        {
            return
        }

        let data = {}
        data.font = font 
        data.variables = variables
        data.hashtag = hashtag
        
        data.start_hashtag = startHashtag 
        data.min_hashtags = minHashtags 
        data.hashtag_rate = hashtagRate 

        data.stop_after = stopAfter
        data.cooldown = cooldown 
        data.preselection = preselection

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ hashtag, font, variables, startHashtag, minHashtags, 
        hashtagRate, stopAfter, cooldown, preselection ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Data source"> 
                <Basic.StringInput name="Hashtag" value={hashtag} setValue={setHashtag}/>
                <Basic.SelectInput name="Selection" value={preselection} setValue={setPreselection} 
                                   options={[
                                { label: "All", value: "all" },
                                { label: "Active in last 1 minutes", value: "active_1_min" },
                                { label: "Active in last 5 minutes", value: "active_5_min" },
                                { label: "Active in last 10 minutes", value: "active_10_min" },
                            ]}
  
                />
            </SettingsGroup>
            <SettingsGroup name="Behaviour"> 
                <Basic.PositiveIntegerInput name="Stop after" value={stopAfter} setValue={setStopAfter} />
                <Basic.PositiveIntegerInput name="cooldown" value={cooldown} setValue={setCooldown} /> 
            </SettingsGroup>
            
            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />

            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={twitchAudiencePickerVariables}
                            reset={reset}
            />

            <SettingsGroup name="Remote Control">
                <Basic.StringInput name="Start hastag" value={startHashtag} setValue={setStartHashtag} />
                <Basic.PositiveIntegerInput name="Min hastags" value={minHashtags} setValue={setMinHashtags} />
                <Basic.SelectInput name="Frequency per viewer" value={hashtagRate} setValue={setHashtagRate} 
                                   options={[
                                        { label: "One time only", value: "one_per_user" },
                                        { label: "Once every 10 seconds", value: "one_every_10_seconds" },
                                        { label: "Once every minute", value: "one_every_minute" },
                                        { label: "Unlimited", value: "unlimited" },
                                    ]}
                /> 
            </SettingsGroup>
        </>
    )
}

